import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormGroupDirective,
} from '@angular/forms';
import { Title } from '@angular/platform-browser';

import { Validations } from '../shared/validations/validations';
import { ToastrService } from 'ngx-toastr';
import { ContactUsService } from './contact-us.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: [
    './contact-us.component.scss',
    '../shared/styles/contact-news.scss',
  ],
})
export class ContactUsComponent implements OnInit {
  contactForm!: FormGroup;
  disabled!: boolean;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private contactSrv: ContactUsService,
    private tSrv: Title
  ) {}

  ngOnInit(): void {
    this.tSrv.setTitle("Contact Us | Don't Waste Money");
    this.contactForm = this.fb.group({
      email: ['', [Validators.required, Validations.emailValidation]],
      name: ['', [Validators.required, Validations.nameValidation]],
      phoneNumber: ['', [Validators.required, Validations.phoneValidation]],
      message: ['', [Validators.required]],
    });
    this.disabled = false;
  }

  submit(cFormRef: FormGroupDirective) {
    if (this.contactForm.valid) {
      this.disabled = true;
      this.contactSrv
        .contact(this.contactForm.value)
        .then((data: any) => {
          if (data) {
            cFormRef.resetForm();
            this.toastr.success(data, 'Success!');
          } else {
            this.toastr.error('Something went wrong', 'Error!');
          }
        })
        .catch((err) => {
          this.toastr.error('Failed to send message', 'Error!');
          console.error('API error:', err);
        })
        .finally(() => {
          this.disabled = false;
        });
    }
  }
}
